<template>
  <div class="study-task-question">
    <div class="desc" >
      {{ desc }}
    </div>
    <div class="btn">
      <button @click="pageAction">填写问卷</button>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'
import utils from '@utils/index'
const props = defineProps({
  desc: {
    type: String,
    default: ""
  },
  url: {
    type: String,
    default: ''
  }
})

const pageAction = () => {
  if (utils.isApp()) {
    utils.postMessage({
      type: 'h5',
      url: props.url
    })
  } else {
    window.open(props.url)
  }
}
</script>

<style lang="scss" scoped>
.study-task-question {
  .desc {
    color: #626366;
    font-size: 28px;
    line-height: 42px;
  }
  .btn {
    text-align: center;
    margin-top: 30px;
    button {
      display: inline-block;
      width: 176px;
      height: 72px;
      border-radius: 36px;
      border: none;
      color: #FF6600;
      font-size: 28px;
      background-color: #f5f5f5;
    }
  }
}
</style>
